import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss']
})
export class ProgressbarComponent implements OnInit {

  @Input() valueInBytes = 0;
  @Input() totalValueInBytes = 100;
  @Input() uploadFailed;
  @Output() resume = new EventEmitter();
  @Input() fileCompleted = 0;
  @Output() closed = new EventEmitter();
  @Output() close = new EventEmitter();

  progress: number = 0;
  showFinishedMessage = false;
  progressValue: number = 0;
  constructor(
    public locale: LocaleService,
  ) {
  }

  ngOnInit(): void {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.totalValueInBytes) {
      this.progressValue = Math.round((this.valueInBytes / this.totalValueInBytes) * 0.9 * 100);
      if (this.fileCompleted === 1) {
        this.progressValue = 100
        this.progress = this.progressValue
        this.showFinishedMessage = this.progress >= 100;
        console.log(this.progress, 'this.progress>>>>>>')
        this.closed.emit()
      } else {
        this.progress = this.progressValue
        this.showFinishedMessage = this.progress >= 100;
      }
    } else {
      this.progress = this.progressValue;
      console.log(this.progress, 'this.progress>>>>>>')
    }
  }

  resumeUpload() {
    this.resume.emit()
  }

  cancel() {
    this.close.emit();
  }

}
